import React, {FC} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';

// todo: импорт любых страниц раньше импорта Layout вызывает ошибку инициализации стора!
// eslint-disable-next-line import/order
import {Layout} from 'components/layout';
// eslint-disable-next-line import/order
import {AuthRouter} from 'app/routes/auth.route';
import {ProtectedRoute} from 'app/routes/protected.route';
import {ChangePasswordPage} from 'pages/change-password-page';
import {ForbiddenPage} from 'pages/forbidden-page';
import {LoginPage} from 'pages/login-page';
import {KerberosLoginPage} from 'pages/login-page/kerberos-login-page/kerberos-login-page';
import {TwoFactorAuthPage} from 'pages/two-factor-auth-page/two-factor-auth-page';
import {
    URL_CHANGE_PASSWORD,
    URL_GET_2FA_CODE,
    URL_HOME,
    URL_LOGIN,
    URL_WIDGETS,
    URL_FORBIDDEN,
    URL_LOGIN_KERBEROS,
    URL_AUTH_ROUTER,
    URL_VERIFY_2FA_CODE,
} from 'shared/constants/urls';

export const AppRoutes: FC = () => (
    <Switch>
        <Route
            path={URL_AUTH_ROUTER}
            exact
            component={AuthRouter}
        />
        <Route
            path={URL_LOGIN}
            exact
            component={LoginPage}
        />
        <Route
            path={URL_LOGIN_KERBEROS}
            exact
            component={KerberosLoginPage}
        />
        <Route
            path={URL_CHANGE_PASSWORD}
            exact
            component={ChangePasswordPage}
        />
        <Route
            path={URL_GET_2FA_CODE}
            exact
            component={TwoFactorAuthPage}
        />
        <Route
            path={URL_VERIFY_2FA_CODE}
            exact
            component={TwoFactorAuthPage}
        />
        <Route
            path={URL_FORBIDDEN}
            exact
            component={ForbiddenPage}
        />
        <ProtectedRoute
            path={URL_HOME}
            component={Layout}
        />
        {/* TODO: Temporary solution */}
        <Redirect
            exact
            from="/"
            to={URL_WIDGETS}
        />
    </Switch>

);
